const featuresData = [
  { icon: 'ri-smartphone-line', title: '全平台覆盖', desc: 'Android、iOS、Windows、Mac 四大平台完整支持，一个账号多端同步观看记录与收藏。' },
  { icon: 'ri-download-cloud-2-line', title: '免费高速下载', desc: '91免费软件全部免费下载，不限速不收费，安装包经过严格安全检测，纯净无捆绑。' },
  { icon: 'ri-4k-line', title: '超清画质播放', desc: '支持4K/蓝光原盘解码，智能画质增强技术，即便低带宽也能获得流畅清晰的看片体验。' },
  { icon: 'ri-shield-check-line', title: '安全隐私保护', desc: '91免费看片的app采用端到端加密传输，不记录观看历史，保护你的隐私不受侵犯。' },
  { icon: 'ri-lightbulb-flash-line', title: 'AI智能推荐', desc: '基于深度学习的内容推荐引擎，精准匹配你的口味，发现更多精彩免费看片内容。' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台优势</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么千万用户选择91免费看片软件</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuresData.slice(0, 3).map((feat, i) => (
            <div key={i} className="p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all group cursor-default">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {featuresData.slice(3).map((feat, i) => (
            <div key={i + 3} className="p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all group cursor-default flex gap-4">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-xl text-accent-700`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}